import React from 'react';
import useCheckRole from '../../../../hooks/useCheckRole';
import CompanyInfoTemplate from '../../../../components/templates/CompanyTemplate/CompanyInfo';
import CompaniesListTemplate from '../../../../components/templates/CompanyTemplate/CompanyList';

function CompanyPage() {
	const isSuper = useCheckRole({
		roleCategory: '회원관리',
		roleName: '법인관리',
		roleType: 'isSuper',
		includeSuper: true,
	});

	return isSuper ? <CompaniesListTemplate /> : <CompanyInfoTemplate />;
}

export default CompanyPage;
